import { Platform, StyleSheet } from 'react-native';

import { THEME } from 'reactor/common';

const {
  BORDER_RADIUS, COLOR, FONT, UNIT, OFFSET, SPACE,
} = THEME;

export default StyleSheet.create({
  container: {
    alignItems: 'flex-start',
    flex: 1,
    display: 'flex',
    marginHorizontal: UNIT,
  },

  finder: {
    display: 'flex',
    flexDirection: 'row',
    borderRadius: BORDER_RADIUS,
    borderColor: COLOR.BASE,
    borderWidth: 1,
    maxHeight: UNIT * 4.4,
  },

  icon: {
    marginVertical: SPACE.S,
    marginRight: SPACE.S,
  },

  input: {
    color: COLOR.TEXT,
    fontWeight: FONT.WEIGHT.BOLD,
    height: UNIT * 4,
    marginBottom: 0,
    minWidth: UNIT * 20,
    fontSize: UNIT * 1.6,
    paddingHorizontal: OFFSET,
    width: UNIT * 32,
    ...Platform.select({
      web: {
        fontFamily: FONT.FAMILY,
        outline: 'none',
      },
    }),
  },
});
